// @flow

import React from 'react';

type Props = {
  isLoading: boolean
}

const Loader = (props: Props) => {
  const className = `loader ${props.isLoading ? 'is-loading' : 'dn'}`;
  return (
    <div className={className} />
  );
};

export default Loader;



// WEBPACK FOOTER //
// ./src/components/shared/Loader.js